import {
  addHours,
  addMinutes,
  addDays,
  setHours,
  setMinutes,
  setSeconds,
  setMilliseconds,
  nextMonday,
} from 'date-fns';

const at9 = d =>
  setMilliseconds(setSeconds(setMinutes(setHours(d, 9), 0), 0), 0);

export const inOneHour = (now = new Date()) =>
  setMilliseconds(setSeconds(addHours(now, 1), 0), 0);
export const tomorrowAt9 = (now = new Date()) => at9(addDays(now, 1));
export const nextMondayAt9 = (now = new Date()) => at9(nextMonday(now));
// Mínimo aceito pelo backend (ScheduledMessage::MIN_LEAD_TIME = 2 minutos).
export const minSchedulable = (now = new Date()) => addMinutes(now, 2);
export const isPastWindow = (date, windowClosesAt) =>
  Boolean(date && windowClosesAt && date > windowClosesAt);
